import styled from "styled-components";

export const Container = styled.div`
    display: grid;

    grid-row-gap: 18px;
    grid-template-columns: 1fr max-content;    
`